export default __webpack_public_path__ + "static/color-roles-and-icons-743bdf6f251b8b7fcc89a1cd8d19cce010e94dd30f3b9532211602574218b786.png";